/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportDemoLoansDto } from '../../models/financial-support-demo-loans-dto';

export interface FinancialSupportDemoControllerFindLoans$Params {
  id: string;
}

export function financialSupportDemoControllerFindLoans(http: HttpClient, rootUrl: string, params: FinancialSupportDemoControllerFindLoans$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportDemoLoansDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportDemoControllerFindLoans.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportDemoLoansDto>;
    })
  );
}

financialSupportDemoControllerFindLoans.PATH = '/api/financial-support/demo-companies/{id}/loans';
